import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';

export function useOverview() {
  return useQuery({
    queryKey: ['analytics', 'overview'],
    queryFn: () => api.get('/api/analytics/overview').then((r) => r.data),
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useYieldTrends(period: string, type: string) {
  return useQuery({
    queryKey: ['analytics', 'yield-trends', period, type],
    queryFn: () => api.get('/api/analytics/yield-trends', { params: { period, type } }).then((r) => r.data),
  });
}

export function useWorkerPerformance() {
  return useQuery({
    queryKey: ['analytics', 'worker-performance'],
    queryFn: () => api.get('/api/analytics/worker-performance').then((r) => r.data),
  });
}

export function usePackages() {
  return useQuery({
    queryKey: ['analytics', 'packages'],
    queryFn: () => api.get('/api/analytics/packages').then((r) => r.data),
  });
}

export function useStoneLifecycle(serial: string | undefined) {
  return useQuery({
    queryKey: ['analytics', 'stone', serial],
    queryFn: () => api.get(`/api/analytics/stone/${encodeURIComponent(serial!)}`).then((r) => r.data),
    enabled: !!serial,
  });
}

export function useStoneSearch(query: string) {
  return useQuery({
    queryKey: ['analytics', 'stone-search', query],
    queryFn: () => api.get('/api/analytics/stone-search', { params: { q: query } }).then((r) => r.data),
    enabled: query.length >= 2,
  });
}

export function useSupplierComparison() {
  return useQuery({
    queryKey: ['analytics', 'supplier-comparison'],
    queryFn: () => api.get('/api/analytics/supplier-comparison').then((r) => r.data),
  });
}

export function usePackageDetail(id: string | undefined) {
  return useQuery({
    queryKey: ['package-detail', id],
    queryFn: () => api.get(`/api/packages/${id}/detail`).then((r) => r.data),
    enabled: !!id,
  });
}

export function useStockSummary(params: Record<string, string>) {
  return useQuery({
    queryKey: ['stock', params],
    queryFn: () => api.get('/api/stock/summary', { params }).then((r) => r.data),
  });
}

export function useJointLots() {
  return useQuery({
    queryKey: ['export', 'joint-lots'],
    queryFn: () => api.get('/api/export/joint-lots').then((r) => r.data),
  });
}

export function useDailyActions() {
  return useQuery({
    queryKey: ['analytics', 'daily-actions'],
    queryFn: () => api.get('/api/analytics/daily-actions').then((r) => r.data),
    refetchInterval: 60_000,
  });
}

export function useRecentPackagesQC() {
  return useQuery({
    queryKey: ['qc', 'recent-packages'],
    queryFn: () => api.get('/api/qc/recent-packages').then((r) => r.data),
  });
}

export function usePendingHandoffs() {
  return useQuery({
    queryKey: ['qc', 'pending-handoffs'],
    queryFn: () => api.get('/api/qc/pending-handoffs').then((r) => r.data),
  });
}

export function useSawingStones() {
  return useQuery({
    queryKey: ['sawing', 'my-stones'],
    queryFn: () => api.get('/api/sawing/my-stones').then((r) => r.data),
  });
}
